import { QueryKeyConfig, MutationKeyConfig } from '../api-helper';

export const rebateCompanyApiKeyStore = {
  createRebateCompany: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_REBATE_COMPANY`],
    route: `/UtilityRebateCompany`,
    action: 'POST',
  }),
  updateRebateCompany: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_REBATE_COMPANY`],
    route: `/UtilityRebateCompany`,
    action: 'PUT',
  }),
  deleteRebateCompany: (id: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_REBATE_COMPANY`, id],
    route: `/UtilityRebateCompany/${id}`,
    action: 'DELETE',
  }),
  getRebateCompanies: (): QueryKeyConfig => ({
    queryKey: [`GET_REBATE_COMPANIES`],
    route: `/UtilityRebateCompany`,
  }),
  getRebateTypes: (): QueryKeyConfig => ({
    queryKey: [`GET_REBATE_TYPES`],
    route: `/UtilityRebateCompany/RebateTypes`,
  }),
  getUtilRebateMappings: (type: string, id: any): QueryKeyConfig => ({
    queryKey: [`GET_UTIL_REBATE_MAPPINGS`, type, id],
    route: `/UtilityRebateCompany/UtilRebateMappings/${type}/${id}`,
    isEnabled: !!id && id > 0,
  }),
};
